import { render, staticRenderFns } from "./UpdateMaxOrderDialog.vue?vue&type=template&id=0c2e1268"
import script from "./UpdateMaxOrderDialog.vue?vue&type=script&lang=js"
export * from "./UpdateMaxOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports